import axios from "axios";
import { baseUrlForAssignments } from "../variables/variables";

const submitArbitratorAssignment = async (formData) => {
  const settings = {
    method: "POST",
    headers: {
      // Authorization: "Bearer " + Suser.token + "",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };
  try {
    const fetchResponse = await fetch(baseUrlForAssignments, settings);
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    return e;
  }
};
const assignArbitratorAssignment = async (updatedStatus) => {
  const settings = {
    method: "POST",
    headers: {
      // Authorization: "Bearer " + Suser.token + "",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updatedStatus),
  };
  try {
    const fetchResponse = await fetch(baseUrlForAssignments, settings);
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    return e;
  }
};

const getAssignments = async (assignmentId) => {
  assignmentId = assignmentId != undefined ? `/` + assignmentId : "";
  const settings = {
    method: "GET",
    headers: {
      // Authorization: "Bearer " + Suser.token + "",
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
  try {
    const fetchResponse = await fetch(
      // `${baseUrlForAssignments}/assignments`,
      baseUrlForAssignments + `${assignmentId}`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    return e;
  }
};
  const MarkAssingmentDelete = (assignmentId) =>{
   return axios.post( baseUrlForAssignments + `/delete/${assignmentId}`,)
  }
   
  const getFilterAssignments = (varaible) =>{
    return axios.get(baseUrlForAssignments+`?`+varaible)
  }


export {
  submitArbitratorAssignment,
  assignArbitratorAssignment,
  getAssignments,
  MarkAssingmentDelete,
  getFilterAssignments
};
